import axios from 'axios';
import Vue from 'vue'

export default {
    saveNews(formData) {
        return axios.post("/api/news/save/", formData)
            .then(response => {

                if (response && response.data) {
                    Vue.prototype.$snotify.success("Actualité ajoutée avec succès");
                    return response.data;
                }
            })
            .catch(error => { Vue.prototype.$snotify.error(error); })
    },

    
    getNews(page, pageSize,supplierId) {
        return axios.get('/api/news/list',{ params: {page: page, pageSize: pageSize, supplierId:supplierId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeNews(newsId) {
        return axios.post('/api/news/delete', {id : newsId})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Actualité supprimé avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


}